import { useQuery, useMutation } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { useParams, useNavigate } from 'react-router';

import { sortToGraphql } from './integrations_container';
import {
  getNodes,
  TelematicsProvidersSimpleListQuery,
  CreateTelematicsIntegrationMutation,
  CreateTelematicsIntegrationMutationVariables,
  PAGINATION_PAGE_SIZE,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CreateIntegrationViewDataProps, CreateIntegrationView } from '../components/create_integration';
import { useIntegrationListSort } from '../components/integration_list';
import {
  telematicsProvidersSimpleListQuery,
  createTelematicsIntegrationMutation,
  telematicsIntegrationsListQuery,
} from '../graphql';

class LoadingContainer extends Loader<TelematicsProvidersSimpleListQuery, CreateIntegrationViewDataProps, object> {}

export const CreateIntegrationContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const navigate = useNavigate();
  const notify = useNotifications();
  const { sort } = useIntegrationListSort();

  const result = useQuery<TelematicsProvidersSimpleListQuery>(telematicsProvidersSimpleListQuery);
  const [createIntegration] = useMutation<
    CreateTelematicsIntegrationMutation,
    CreateTelematicsIntegrationMutationVariables
  >(createTelematicsIntegrationMutation, {
    refetchQueries: [
      {
        query: telematicsIntegrationsListQuery,
        variables: {
          companyId: company_id,
          limit: PAGINATION_PAGE_SIZE,
          sort: sortToGraphql(sort),
        },
      },
    ],
  });

  return (
    <LoadingContainer
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      result={result as any}
      mapData={({ data }) => ({
        data: { company_id, telematicsProviders: getNodes(data.telematicsProvidersV2?.providers) },
      })}>
      {({ data }) => (
        <CreateIntegrationView
          data={data}
          createIntegration={async (input) => {
            const response = await createIntegration(input);
            notify.success({ title: 'Integration added' });
            return response;
          }}
          routeProps={{ push: (path: string) => navigate(path), goBack: () => navigate(-1) }}
        />
      )}
    </LoadingContainer>
  );
};
